import { action, makeObservable, observable, runInAction } from 'mobx';
import { AsyncState } from 'shared/libs/state';
import { ApiResponseDto } from 'shared/types';
import { FavoritesApiService } from './FavoritesApiService';
import { AddToFavoriteDto, FavFolder } from './types';

export class FavoritesStore {
   readonly createFolderState = new AsyncState<ApiResponseDto<string>>();
   readonly loadfavoritesListState = new AsyncState<FavFolder[]>();
   readonly addToFavoriteState = new AsyncState<ApiResponseDto<string>>();

   folderName: string = '';
   favFolders: FavFolder[] = [];

   constructor() {
      makeObservable(this, {
         folderName: observable,
         favFolders: observable,
         setFolderName: action,
      });
   }

   setFolderName(f: string) {
      this.folderName = f;
   }

   async createFolder({ onSuccess, onError }: { onSuccess?: () => void; onError?: () => void }) {
      await this.createFolderState.run(
         () => FavoritesApiService.createFavoriteFolder({ name: this.folderName }),
         {
            onSuccess: (data) => {
               if (data) {
                  this.loadFavFolderList({});
                  this.setFolderName('');
               }
               onSuccess?.();
            },
            onError,
         }
      );
   }

   async addToFavorite(
      dto: AddToFavoriteDto,
      params: {
         candidateId: number;
         cvId: number;
      },
      { onSuccess, onError }: { onSuccess?: () => void; onError?: () => void }
   ) {
      await this.addToFavoriteState.run(() => FavoritesApiService.addToFavorite(dto, params), {
         onSuccess: (data) => {
            onSuccess?.();
         },
         onError,
      });
   }

   async loadFavFolderList({
      onSuccess,
      onError,
   }: {
      onSuccess?: () => void;
      onError?: () => void;
   }) {
      await this.loadfavoritesListState.run(() => FavoritesApiService.getFavoritesFolderList(), {
         onSuccess: (data) => {
            runInAction(() => {
               this.favFolders = data;
            });
            onSuccess?.();
         },
         onError,
      });
   }
}
